class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("#predictive-search");

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
		.then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        })
        .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;

            setTimeout(() => {
                searchSplideProducts();
            }, 0);

            this.open();
        })
        .catch((error) => {
            this.close();
            console.error('Error fetching search results:', error);
        });
	}

	open() {
		const header = document.querySelector("header");
		if (header.classList.contains("mm-open")) {
			this.predictiveSearchResults.style.zIndex = 2;
		}
		this.predictiveSearchResults.style.display = "block";
		document.querySelector("html").classList.add("stop-scrolling");

		this.querySelector(".mm-header-bg-filter").classList.add("mm-visible");

		const filterElement = this.querySelector(".mm-header-bg-filter");
		if (filterElement) {
			filterElement.classList.add("mm-visible");
			// Ajout de l'écouteur d'événements au moment de l'ouverture
			filterElement.addEventListener("click", this.close.bind(this));
		}

		const closeHeader = document.querySelector(".mm-header-burger .burger");
		if (closeHeader) {
		closeHeader.addEventListener("click", this.close.bind(this));
		}
	}

	close() {
		const header = document.querySelector("header");
		if (header.classList.contains("mm-open")) {
			this.predictiveSearchResults.style.zIndex = 0;
		} else {
			document.querySelector("html").classList.remove("stop-scrolling");
		}
		this.predictiveSearchResults.style.display = "none";

		const bgFilter = this.querySelector(".mm-header-bg-filter");
		if (bgFilter) {
			bgFilter.classList.remove("mm-visible");
		}
		
		// Réinitialisation de la valeur de l'input
		this.input.value = "";
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define('predictive-search', PredictiveSearch);

